import { render } from "./InputWithIcon.vue?vue&type=template&id=b95d5ed6"
import script from "./InputWithIcon.vue?vue&type=script&lang=js"
export * from "./InputWithIcon.vue?vue&type=script&lang=js"
script.render = render

export default script